import { render } from "./InviteWorkspaceMember.vue?vue&type=template&id=ca58f790"
import script from "./InviteWorkspaceMember.vue?vue&type=script&lang=js"
export * from "./InviteWorkspaceMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__